import { IApiMap } from "../../IApiMap"

export interface IReportPDFDefinition {
  additionalFieldData: IApiMap<string[]>
}

export class ReportPDFDefinition implements IReportPDFDefinition {
  additionalFieldData: IApiMap<string[]>

  constructor(){
    this.additionalFieldData = {}
  }
}
